import { font, colors, spacing, breakpoints } from '@chegg-ui/theme';
import styled from 'styled-components';
export var MultiMenuContainer = styled.div.withConfig({
  componentId: "sc-1e8btw0-0"
})(["display:flex;justify-content:center;align-items:stretch;box-sizing:border-box;@media (max-width:", "){flex-direction:column;}"], breakpoints.md.max);
export var MenuListContainer = styled.div.withConfig({
  componentId: "sc-1e8btw0-1"
})(["box-sizing:border-box;display:flex;flex-direction:column;"]);
export var MenuTitle = styled.span.withConfig({
  componentId: "sc-1e8btw0-2"
})(["text-align:left;font-size:", ";text-transform:uppercase;color:", ";padding:", " 0;@media (max-width:", "){padding-left:", ";}"], font.size.px14, colors.grey, spacing.px16, breakpoints.md.max, spacing.px8);
export var MenuDivider = styled.div.withConfig({
  componentId: "sc-1e8btw0-3"
})(["border-left:1px solid ", ";margin:", " ", " ", " ", ";@media (max-width:", "){display:none;}"], colors.greyLight, spacing.px64, spacing.px32, spacing.px16, spacing.px32, breakpoints.md.max);